/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ partners: NonNullable<unknown>, invoiced: NonNullable<unknown>, paid: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_SettledInputs */



/**
* | output |
* | --- |
* | "{partners} partners · {invoiced} invoiced, {paid} paid · {amount}" |
*
* @param {Partner_Billing_Board_Meta_SettledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_settled = /** @type {((inputs: Partner_Billing_Board_Meta_SettledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_SettledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.partners} Partner · ${i?.invoiced} fakturiert, ${i?.paid} bezahlt · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.partners} partners · ${i?.invoiced} invoiced, ${i?.paid} paid · ${i?.amount}`)
});